if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };

        this.drawerBody = this.querySelector(this.selector);

        /* TR CART QUICK VIEW:
           Watch for variant-picker rerenders */
        if (this.classList.contains('tr-cart-upsell-quick-view')) {
          this.trMutationObserver = new MutationObserver(() => {
            this.hideTRCartQuickViewExtras();
          });

          if (this.drawerBody) {
            this.trMutationObserver.observe(this.drawerBody, {
              childList: true,
              subtree: true,
            });
          }
        }
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();

        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: {
              productUrl: this.dataset.productUrl,
            },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();

        const drawerContent = this.querySelector(this.selector);

        drawerContent.innerHTML = '';

        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          const productQuickView = document.querySelector(
            '.section-group-overlay-quick-view'
          );

          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      /* =====================================================
         TR CART QUICK VIEW CLEANUP
         ===================================================== */

      hideTRCartQuickViewExtras() {
        if (!this.classList.contains('tr-cart-upsell-quick-view')) {
          return;
        }

        /* Remove SIZE GUIDE even after color/variant rerenders */
        this.querySelectorAll(
          '.quick-view__content a, .quick-view__content button, .quick-view__content [role="button"]'
        ).forEach((el) => {
          const text = el.textContent
            .replace(/\s+/g, ' ')
            .trim()
            .toUpperCase();

          if (text === 'SIZE GUIDE') {
            el.style.setProperty('display', 'none', 'important');
          }
        });
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);

        const sectionId = this.getProductQuickViewSectionId();

        const sectionUrl = `${
          this.dataset.productUrl.split('?')[0]
        }?section_id=${sectionId}`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            if (!productElement) {
              console.error(
                'Quick View product content could not be found.'
              );

              return;
            }

            this.setInnerHTML(
              drawerContent,
              productElement.content.cloneNode(true)
            );

            /* Remove SIZE GUIDE on initial load */
            this.hideTRCartQuickViewExtras();

            FoxTheme.a11y.trapFocus(
              this,
              this.focusElement
            );

            if (
              window.Shopify &&
              Shopify.PaymentButton
            ) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(
                this._classes.loaded
              );
            }, 300);

            document.dispatchEvent(
              new CustomEvent(
                'quick-view:loaded',
                {
                  detail: {
                    productUrl:
                      this.dataset.productUrl,
                  },
                }
              )
            );
          })
          .catch((e) => {
            console.error(
              'Quick View error:',
              e
            );
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';

        element.appendChild(innerHTML);

        element
          .querySelectorAll('script')
          .forEach((oldScriptTag) => {
            const newScriptTag =
              document.createElement(
                'script'
              );

            Array.from(
              oldScriptTag.attributes
            ).forEach((attribute) => {
              newScriptTag.setAttribute(
                attribute.name,
                attribute.value
              );
            });

            newScriptTag.appendChild(
              document.createTextNode(
                oldScriptTag.innerHTML
              )
            );

            oldScriptTag.parentNode.replaceChild(
              newScriptTag,
              oldScriptTag
            );
          });
      }

      disconnectedCallback() {
        super.disconnectedCallback();

        if (this.trMutationObserver) {
          this.trMutationObserver.disconnect();
        }

        this.handleAfterHide();
      }
    }
  );
}